import { render } from "./Preview3D.vue?vue&type=template&id=5399ec8c"
import script from "./Preview3D.vue?vue&type=script&lang=js"
export * from "./Preview3D.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__